import React from "react";
import {
  LineChart,
  lineElementClasses,
  areaElementClasses,
} from "@mui/x-charts/LineChart";

interface SeriesData {
  data: number[];
  label: string;
}

interface AreaLineChartProps {
  series: SeriesData[];
  xLabels: string[];
  width?: number;
  height?: number;
}

export const AreaLineChart: React.FC<AreaLineChartProps> = ({
  series,
  xLabels,
  width = 500,
  height = 300,
}) => {
  return (
    <LineChart
      width={width}
      height={height}
      series={series.map((s) => ({
        ...s,
        area: true,
        stack: "total",
        showMark: false,
        color: "#00ADEF",
      }))}
      xAxis={[{ scaleType: "point", data: xLabels }]}
      sx={{
        [`& .${areaElementClasses.root}`]: {
          fill: "#92CAEB",
        },
        [`& .${lineElementClasses.root}`]: {},
        "& .MuiChartsAxis-tickLabel": {
          fill: "#7B7B7B", // X and Y axis label color
          fontSize: 14,
        },
        "& .MuiChartsAxis-line": {
          stroke: "#6B6B6C", // X and Y axis line color
          strokeWidth: 2,
        },
        "& .MuiChartsAxis-tick": {
          stroke: "#6B6B6C", // Tick marks color
          strokeWidth: 1.5,
        },
        "& .MuiChartsLegend-root": {
          display: "none", // hides the label title of the series
        },
      }}
    />
  );
};
